import { render, staticRenderFns } from "./UrlLanguagesForm.vue?vue&type=template&id=b8c422a4&"
import script from "./UrlLanguagesForm.vue?vue&type=script&lang=js&"
export * from "./UrlLanguagesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports